import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=01bb5cd0&scoped=true&"
import script from "./CommentField.vue?vue&type=script&lang=js&"
export * from "./CommentField.vue?vue&type=script&lang=js&"
import style0 from "./CommentField.vue?vue&type=style&index=0&id=01bb5cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb5cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VChip,VIcon,VTextarea})
